/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import DeathContainer from './container/DeathContainer';
import SearchContainer from './container/search/SearchContainer';
import DeathCertificateListingContainer from './container/records/container/DeathCertificateListingContainer';

function TabDeath({ match, pathName, permissions }) {
  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/transactions'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Death Certificate
                </Link>
              </li>
              {Acl(permissions, ['SEARCH DEATH CERTIFICATE']) && (
                <li className="nav-item">
                  <Link
                    to="/civil-registry/death-certificate/search"
                    className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                      pathName.indexOf(
                        '/civil-registry/death-certificate/search'
                      ) > -1
                        ? 'selected'
                        : ''
                    }`}
                  >
                    Search
                  </Link>
                </li>
              )}
              <li className="nav-item">
                <Link
                  to="/civil-registry/death-certificate/records-maintenance"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${
                    pathName.indexOf(
                      '/civil-registry/death-certificate/records-maintenance'
                    ) > -1
                      ? 'selected'
                      : ''
                  }`}
                >
                  Record Maintenance
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/transactions`} />}
          />
          <Route
            path={`${match.path}/transactions`}
            component={DeathContainer}
          />
          <Route path={`${match.path}/search`} component={SearchContainer} />
          <Route
            path={`${match.path}/records-maintenance`}
            component={DeathCertificateListingContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

TabDeath.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(TabDeath);
